/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/modules/shop/components/artikel-status-icon/shop.artikel-status-icon.component.ts.
 */
import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {Artikel} from '../../../../models/artikel';

/**
 * Zweck: Beschreibt class ShopArtikelStatusIconComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    selector: 'artikel-status-icon',
    templateUrl: 'shop.artikel-status-icon.component.html',
    styleUrls: ['shop.artikel-status-icon.component.scss'],
    standalone: false
})
export class ShopArtikelStatusIconComponent implements OnChanges, OnInit {
  @Input() artikel: Artikel;

  @Input() showTooltip = true;

  color = '';
  icon = '';
  iconColor = '';

  VerfuegbarkeitsstatusText = '';

/**
 * Beschreibt Methode fixState und ihren Rückgabevertrag.
 */
  fixState() {
    if (this.artikel) {
      this.VerfuegbarkeitsstatusText = this.artikel.VerfuegbarkeitsstatusText;

      if (this.artikel.Artikelstamm != 'DE' || (this.artikel.Artikelstamm == 'DE' &&
        // @ts-ignore
        (this.artikel.ArtikelNummer != null && (this.artikel.PZN != '' || this.artikel.PZN != '0000000')))) {
        if (this.artikel.VerfuegbarkeitsstatusCode == '0G') {
          this.color = 'green';
          this.icon = 'check';
          this.iconColor = 'white';

        } else if (this.artikel.VerfuegbarkeitsstatusCode == 'NL') {
          this.color = 'orange';
          this.icon = '';

        } else if (this.artikel.VerfuegbarkeitsstatusCode == 'KO') {
          this.color = 'orange';
          this.icon = '';
          this.VerfuegbarkeitsstatusText += ' (Kontingentartikel)';

        } else {
          this.color = 'red';
          this.icon = 'abbrechen';
          this.iconColor = 'white';
        }
      } else {
        this.color = 'blue';
        this.icon = '';

      }
    }
  }

/**
 * Beschreibt Methode ngOnChanges und ihren Rückgabevertrag.
 */
  ngOnChanges(changes: SimpleChanges): void {
    this.fixState();
  }

/**
 * Beschreibt Methode ngOnInit und ihren Rückgabevertrag.
 */
  ngOnInit(): void {
    this.fixState();
  }


}
